import type { IntlShape } from 'react-intl';

import DefaultExtensionProvider from '@atlaskit/editor-common/extensions/default-extension-provider';
import type { ExtensionProvider } from '@atlaskit/editor-common/extensions/extension-provider';

import type { Snippet } from '../types/snippet.ts';

import { snippetExtensionManifest } from './snippetExtensionManifest.tsx';

export const snippetExtensionProvider = (
	intl: IntlShape,
	snippets: Snippet[],
	onOpenTemplatePanel?: () => void,
	userId?: string | null,
): ExtensionProvider => {
	if (!onOpenTemplatePanel && (!snippets || snippets.length === 0)) {
		return new DefaultExtensionProvider([]);
	}

	const manifest = snippetExtensionManifest({
		snippets: snippets || [],
		intl,
		onOpenTemplatePanel,
		userId,
	});

	return new DefaultExtensionProvider([manifest]);
};
